import React, { FC, useState, useEffect } from "react";


interface IUpperTokensBar {
    numberOfPoints: number;
}

const UpperTokensBar: FC<IUpperTokensBar> = ({ numberOfPoints }) => {
    const [reanimateToken, setReanimateToken] = useState(false);

    useEffect(() => {
        if (reanimateToken) {
            const textAnimate = setTimeout(() => {
                setReanimateToken(false);
            }, 2000);

            return () => clearTimeout(textAnimate);
        }
    }, [reanimateToken]);

    useEffect(() => {
        const textAnimate = setTimeout(() => {
            setReanimateToken(true);
        }, 1500);

        return () => clearTimeout(textAnimate);
    }, [numberOfPoints]);

    const renderTokens = () => {
        return (
            <div>
                <div className={reanimateToken ? "animate" : "tokens"}> {numberOfPoints} </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {renderTokens()}
        </React.Fragment>
    );
}

export default UpperTokensBar;